import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderCell,
} from "style/components";
import api from "scripts/utils/api";
import JourneyGroupsTableRow from "./journey-groups-table-row";
import PageLayoutWithButtons from "apps/layout/components/page-layout-with-buttons";

const JourneyGroupsTable = () => {
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    api.JOURNEYS.GROUPS.get().then((response) => {
      setGroups(response.data);
    });
  }, []);

  return (
    <PageLayoutWithButtons
      title={"Groups"}
      subtitle='Assign people to a group so that a set of cadences is only visible
  to them. To start creating a custom cadence for a group, click on
  the "Cadences" tab in data.evertrue.com.'
      buttons={[
        { key: 1, label: "Add Group", onClick: () => {}, type: "default" },
      ]}
    >
      <Table>
        <TableHeader>
          <TableHeaderCell>Group</TableHeaderCell>
          <TableHeaderCell></TableHeaderCell>
        </TableHeader>
        <TableBody>
          {groups.map((group) => (
            <JourneyGroupsTableRow group={group} key={group.id} />
          ))}
        </TableBody>
      </Table>
    </PageLayoutWithButtons>
  );
};

export default JourneyGroupsTable;
